import { TaskInput } from 'interfaces/ITask.interface';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { CQInput } from './cq-input';
import Icon from '@salesforce/design-system-react/components/icon';

export interface CQInputsProps {
    taskInputs: TaskInput[] | undefined,
    variables: any;
    onVariableChange?: (attribute: string, newValue: any) => void;
}

export function CQInputs({taskInputs, variables, onVariableChange} : CQInputsProps){
    
    const {t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    
    return <>
        {
            taskInputs === undefined || taskInputs.length === 0 ? <></> :
            <div>
                <div className="slds-text-body_small"><Icon name="custom_apps" category="utility" size="x-small"></Icon>
                    <button className="slds-button slds-var-m-left_small" onClick={() => {
                        setIsExpanded(!isExpanded);
                    }} >{t("task_options")}</button>
                </div>
                {isExpanded ? 
                    <div className="slds-box slds-var-m-bottom_small">
                        <table className="slds-table slds-table_cell-buffer slds-table_bordered slds-table_striped">
                                <thead>
                                    <tr className="slds-line-height_reset">
                                        <th className="" scope="col">
                                            <div className="slds-truncate" title="Opportunity Name">{t("task_input_attribute")}</div>
                                        </th>
                                        <th className="" scope="col">
                                            <div className="slds-truncate" title="Opportunity Name">{t("task_input_value")}</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {taskInputs.map(input => 
                                        <tr><td>{t("task_input_" + input.name)}</td>
                                        <td><CQInput taskInput={input} onInputChange={onVariableChange || ((attribute, newValue) => {
                                            variables[attribute] = newValue;
                                        })}></CQInput></td>
                                        </tr>
                                    )}
                                </tbody>
                        </table>
                    </div>
                : <></> }
            </div> 
        }
    </>
}